import { IconDefinition } from "./types";

const filePen: IconDefinition = {
  iconName: "file-pen",
  width: 640,
  height: 512,
  svgPathData:
    "M240 48l-128 0 0 416 172.2 0-8 48-212.2 0 0-512 224 0 160 160 0 107.7-48 48 0-107.7-160 0 0-160zM380.1 160l-92.1-92.1 0 92.1 92.1 0zM544 239.9l80 80-52.8 52.8-80-80 52.8-52.8zm-208 208l132.6-132.6 80 80-132.6 132.6-96 16 16-96z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "file-pen",
  unicode: 0xf31c,
};

export { filePen };
